// src/data/materialesDB.js
const materials = 
[
  {
    id: 'mat-3001',
    codigo: 'MAT-3001',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 7X20X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 } // precio por unidad
    ],
    dimensions:
    {
      width: 0.07, // meters
      height: 0.20, //meters
      length: 0.41, // meters
      weight: 5.76, //kilograms
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3002"
    },
    image: null
  },
  {
    id: 'mat-3002',
    codigo: 'MAT-3002',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 7X20X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions: 
    {
      width: 0.07, //meters
      height: 0.20, //meters
      length: 0.20, //meters
      weight: 3.95, //kilograms
    },
    properties: 
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3003',
    codigo: 'MAT-3003',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 7X30X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 }
    ],
    dimensions:
    {
      width: 0.07,
      height: 0.30,
      length: 0.41,
      weight: 7.90
    },
    properties: 
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3004"
    },
    image: ""
  },
  {
    id: 'mat-3004',
    codigo: 'MAT-3004',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 7X30X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions: 
    {
      width: 0.07,
      height: 0.30,
      length: 0.20,
      weight: 4.65
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3005',
    codigo: 'MAT-3005',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 9X30X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 }
    ],
    dimensions:
    {
      width: 0.09,
      height: 0.30,
      length: 0.41,
      weight: 9.30
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3006"
    },
    image: ""
  },
  {
    id: 'mat-3006',
    codigo: 'MAT-3006',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 9X30X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions: 
    {
      width: 0.09,
      height: 0.30,
      length: 0.20,
      weight: 4.65
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3007',
    codigo: 'MAT-3007',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 10X20X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 }
    ],
    dimensions:
    {
      width: 0.10,
      height: 0.20,
      length: 0.41,
      weight: 8.30
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3008"
    },
    image: ""
  },
  {
    id: 'mat-3008',
    codigo: 'MAT-3008',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 10X20X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.10,
      height: 0.20,
      length: 0.20,
      weight: 4.15
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3009',
    codigo: 'MAT-3010',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 14X30X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 }
    ],
    dimensions: 
    {
      width: 0.14,
      height: 0.30,
      length: 0.41,
      weight: 12.50
    },
    properties: 
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3010"
    },
    image: ""
  },
  {
    id: 'mat-3010',
    codigo: 'MAT-3010',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 14X30X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.14,
      height: 0.30,
      length: 0.20,
      weight: 6.25
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3011',
    codigo: 'MAT-3011',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 20X20X41 ROJO RAYADO',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 1.19 }
    ],
    dimensions:
    {
      width: 0.20,
      height: 0.20,
      length: 0.41,
      weight: 13.60
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "standard",
      half: "mat-3012"
    },
    image: ""
  },
  {
    id: 'mat-3012',
    codigo: 'MAT-3012',
    brand: "DOLMEN",
    name: 'LADRILLO EXP 20X20X20 ROJO RAYADO (TRABA)',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.20,
      height: 0.20,
      length: 0.20,
      weight: 6.80
    },
    properties:
    {
      color: "#b85a4a",
      use: 'walls',
      type: "brick",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3013',
    codigo: 'MAT-3013',
    brand: "BOONKER",
    name: 'BLOQUE 25 x 12.5 x 15',
    unit: 'unit',
    prices: 
    [
      { fecha: '818589', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.125,
      height: 0.15,
      length: 0.25,
      weight: 6.80
    },
    properties:
    {
      color: "#818589",
      use: 'walls',
      type: "block",
      subtype: "standard",
      half: "mat-3014"
    },
    image: null
  },
  {
    id: 'mat-3014',
    codigo: 'MAT-3014',
    brand: "BOONKER",
     name: 'BLOQUE 12.5 x 12.5 x 15',
    unit: 'unit',
    prices: 
    [
      { fecha: '1685292654921', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.125,
      height: 0.15,
      length: 0.125,
      weight: 6.80
    },
    properties:
    {
      color: "#818589",
      use: 'walls',
      type: "block",
      subtype: "half",
      half: null
    },
    image: null
  },
  {
    id: 'mat-3015',
    codigo: 'MAT-3015',
    brand: "BOONKER",
    name: 'BLOQUE 37.5 x 12.5 x 15',
    unit: 'unit',
    prices: 
    [
      { fecha: '818589', precio: 0.60 }
    ],
    dimensions:
    {
      width: 0.125,
      height: 0.15,
      length: 0.375,
      weight: 6.80
    },
    properties:
    {
      color: "#818589",
      use: 'walls',
      type: "block",
      subtype: "standard",
      half: "mat-3014"
    },
    image: null
  },
];

export default materials;